<template>
  <section class="search--content">
    <!--    <div class="top&#45;&#45;part">-->
    <!--      <h2 class="title&#45;&#45;text">-->
    <!--        <span class="bold">-->
    <!--          {{ totalUnit ? totalUnit : '0' }}-->
    <!--        </span>-->
    <!--        {{ seoText }}-->
    <!--      </h2>-->
    <!--      <div class="sort">-->
    <!--        <div-->
    <!--          class="filter&#45;&#45;button hide&#45;&#45;in-tablet hide&#45;&#45;in-desktop"-->
    <!--          @click="openFilterSidebar()"-->
    <!--          v-if="$route.name !== 'search-user-listing'"-->
    <!--        >-->
    <!--          <img src="@/assets/img/icons/filter.svg" />-->
    <!--          <div>Filter</div>-->
    <!--        </div>-->
    <!--        <div class="hide&#45;&#45;in-mobile" style="width: 30%" v-else></div>-->
    <!--        <div class="d-flex align-center" style="justify-self: end">-->
    <!--          <div class="sort&#45;&#45;text">{{ $t('general.filter.sort') }}</div>-->
    <!--          <v-select-->
    <!--            :value="activeSortBy"-->
    <!--            @input="inputSortByHandler"-->
    <!--            :items="sortBys"-->
    <!--            :item-text="sortByLabel"-->
    <!--            item-value="id"-->
    <!--            class="dropdown basic&#45;&#45;dropdown"-->
    <!--            solo-->
    <!--            hide-details-->
    <!--          ></v-select>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="bottom--part">
      <div class="hide--in-tablet hide--in-desktop">
        <button type="button" @click="openFilterSidebar()" class="btn filter--btn">
          <v-icon class="icon-filter">mdi-filter</v-icon>Filter
        </button>
      </div>

      <div class="card--project-wrapper owner-connect-grid">
        <div v-for="listing in listings" :key="listing.id" class="project--item">
          <card-owner-connect
            class="card--project-search"
            :listing="listing"
            :is-shortlist="false"
          ></card-owner-connect>
        </div>
      </div>

      <pagination
        v-if="metaProject"
        :push-state="false"
        :meta="metaProject.pagination"
        @changePage="onChangePage"
        :maxVisibleButtons="5"
      />
    </div>
  </section>
</template>

<script>
import CardOwnerConnect from '@/components/utils/card-owner-connect.vue';
const Pagination = () => import('@/components/utils/fractal-pagination.vue');
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'search-content',
  components: {
    CardOwnerConnect,
    Pagination,
  },
  computed: {
    ...mapState({
      metaProject: (state) => state.searchListing.meta,
      projects: (state) => state.searchListing.projects,
      listings: (state) => state.searchListing.listings,
      premierProjects: (state) => state.searchListing.premierProjects,
      selectedPropertyType: (state) => state.searchListing.selectedPropertyType,
      selectedListingType: (state) => state.searchListing.selectedListingType,
      totalUnit: (state) => state.searchListing.totalUnit,
      searchTerm: (state) => state.searchListing.searchTerm,
    }),
    ...mapGetters({
      activeSortBy: 'searchListing/activeSortBy',
      sortBys: 'searchListing/sortBys',
      isSecondary: 'searchListing/isSecondary',
      seoText: 'searchListing/seoText',
    }),
  },
  methods: {
    sortByLabel(value) {
      return this.$i18n.t(`general.filter.${value.name}`);
    },
    inputSortByHandler(value) {
      let sortBy = this.sortBys.find(function (item) {
        return item.id === value;
      });
      this.$store.commit('searchListing/SET_SORT_BY', sortBy);
      this.$store.dispatch('searchListing/goToSearchPage', {
        router: this.$router,
        params: this.$route.params,
      });
    },
    onChangePage(page) {
      this.$store.commit('searchListing/SET_PAGE', page ? page : 1);
      // DO NOT SET SEED TO NULL WHEN CHANGING PAGE
      // this.$store.commit('searchListing/SET_SEED', null);
      this.$store.dispatch('searchListing/goToSearchPage', {
        router: this.$router,
        params: this.$route.params,
      });
    },
    openFilterSidebar() {
      this.$store.commit('searchListing/SET_ACTIVE_FILTER_SIDEBAR', true);
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/utils/variables';
.filter--btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 0 14px;
  background-color: #ffffff !important;
  border: 1px solid #e7e7e7;
  color: #333333 !important;
  margin-bottom: 16px;
  border-radius: 12px;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 13px;
  box-shadow: 0 8px 18px rgba(33, 33, 33, 0.06);

  .icon-filter {
    color: $color-beliruma-1;
    margin-right: 8px;
    font-size: 18px;
  }
}

.owner-connect-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;

  .project--item {
    min-width: 0;
  }

  @media #{$phones, $tablets} {
    grid-template-columns: 1fr;
  }
}

@media #{$tablets} {
  .search--content .bottom--part .card--project-wrapper.owner-connect-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
